import { FC, forwardRef, Ref } from "react";
import { IonRadioGroup } from '@ionic/react';
import { AllieRadioGroupsProps } from "./RadioGroup.types";

export const AllieRadioGroup: FC<AllieRadioGroupsProps> = forwardRef(
  ({...props} : AllieRadioGroupsProps, ref) => <IonRadioGroup {...props} ref={ref as Ref<HTMLIonRadioGroupElement>} />
);
